import { Typography } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles from './styles/ExpandableBoxRow.Skeleton.styles'

interface ExpandableBoxRowSkeletonProps {
  depth: number
}

const ExpandableBoxRowSkeleton: React.FC<ExpandableBoxRowSkeletonProps> = ({
  depth
}) => {
  const classes = useStyles({ depth })

  return (
    <div>
      <Typography variant="body1">
        <Skeleton animation="wave" className={classes.skeleton} />
      </Typography>
    </div>
  )
}

export default ExpandableBoxRowSkeleton
